import ContractPage from 'screens/Contract/Contract';

export default ContractPage;
